export const IconCursor = ({
  width = 12,
  height = 12,
  color = '#fff',
  rotation = 0,
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 13 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask maskUnits='userSpaceOnUse' x='0' y='0' width='13' height='12'>
      <rect x='0.5' width={width} height={height} fill={color} />
    </mask>
    <g mask='url(#mask0_47_2781)'>
      <path
        d='M3.7 9L3 8.3L7.8 3.5H3.5V2.5H9.5V8.5H8.5V4.2L3.7 9Z'
        fill={color}
      />
    </g>
  </svg>
);
